import React from "react"

export default function TriangleMain() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="678.016"
      height="1079.993"
      viewBox="0 0 678.016 1079.993"
    >
      <path
        id="TriangleMain"
        data-name="Triangle Main"
        d="M3312,2558h678.016V3637.993Z"
        transform="translate(-3312 -2558)"
        fill="#738582"
      />
    </svg>
  )
}
